import { render, staticRenderFns } from "./novice-guide.vue?vue&type=template&id=c93a9118&scoped=true"
import script from "./novice-guide.vue?vue&type=script&lang=js"
export * from "./novice-guide.vue?vue&type=script&lang=js"
import style0 from "./novice-guide.vue?vue&type=style&index=0&id=c93a9118&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93a9118",
  null
  
)

export default component.exports